// The inbox v4 palette, light and dark, read from the v4 design board.
export const SERIF_FONT = '"Instrument Serif", Georgia, serif';

const LIGHT = {
  ink: '#0A0A0A', onInk: '#FFFFFF', page: '#FFFFFF',
  card: '#FFFFFF', cardLine: '#ECECEF', note: '#55555A', meta: '#8E8E93', line: '#4A4A4F',
  chipLine: '#E1E1E6', tagBg: '#F2F2F4', tagInk: '#4A4A4F', tile: '#0A0A0A',
  well: '#F4F4F5', pill: '#FFFFFF', slot: '#FFFFFF', slotSub: '#6B6B70', radio: '#C7C7CC',
  hair: '#F0F0F2', togOff: '#E3E3E8', track: '#F2F2F4', chevron: '#B4B4BA', statLabel: '#6B6B70',
  draft: { bg: '#0A0A0A', ink: '#FFFFFF', muted: '#B8B8BE', solidBg: '#FFFFFF', solidInk: '#0A0A0A', ghostBg: '#1F1F22', ghostInk: '#FFFFFF' },
  markRing: 'none',
};

const DARK = {
  ink: '#FFFFFF', onInk: '#0A0A0A', page: '#000000',
  card: '#1C1C1E', cardLine: '#1C1C1E', note: '#A1A1A6', meta: '#8E8E93', line: '#C7C7CC',
  chipLine: '#3A3A3E', tagBg: '#2C2C2E', tagInk: '#C7C7CC', tile: '#2C2C2E',
  well: '#1C1C1E', pill: '#2C2C2E', slot: '#2C2C2E', slotSub: '#A1A1A6', radio: '#636366',
  hair: '#2C2C2E', togOff: '#3A3A3E', track: '#2C2C2E', chevron: '#636366', statLabel: '#8E8E93',
  draft: { bg: '#FFFFFF', ink: '#0A0A0A', muted: '#6B6B70', solidBg: '#0A0A0A', solidInk: '#FFFFFF', ghostBg: '#F2F2F4', ghostInk: '#0A0A0A' },
  markRing: '0 0 0 1px #3A3A3E',
};

export function inboxPalette(ctx) {
  return ctx?.appearance === 'dark' ? DARK : LIGHT;
}
